module.exports = __webpack_public_path__ + "img/facebook.d286d53c.png";